export default "__VITE_ASSET__7c376607__"